// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__MF+vR","label":"styles_label__LC-k+"};